// extracted by mini-css-extract-plugin
module.exports = {"hero":"blog-post-module--hero--TcLt-","heroImage":"blog-post-module--heroImage--3TtTI","body":"blog-post-module--body--1vo0y"};